import React, {Component} from 'react';
import Section from '../section2.0';
import PropTypes from 'prop-types';
import {Player} from 'video-react';
import "video-react/dist/video-react.css";


class index extends Component {


	constructor(props) {
		super(props);
		this.state = {
			currentIndex: 0,
			selectedSection: this.props.part ? this.props.part.sections[0] : null
		}
	}


	componentDidUpdate(prevProps, prevState) {
		if(prevProps.part !== this.props.part){
			this.setState({
				currentIndex: 0,
				selectedSection: this.props.part ? this.props.part.sections[0] : null
			});
			if(this.refs.player){
				this.refs.player.load();
			}
		}
	}


	handleSelectOnClick(section, index) {
		this.setState({
			currentIndex: index,
			selectedSection: section
		});
	};


	renderSectionButtons(sections) {
		return (
			<div className="part-selector no-btm-margin section-selector">
				{sections.map((section, index) => {
					let className = this.state.currentIndex === index ? "active" : "";
					return (<li key={index}><a onClick={() => this.handleSelectOnClick(section, index)} className={className}>{section.label}</a></li>)
				})}
			</div>);
	}

	render() {
		if(this.props.part){
			let section = this.state.selectedSection || null;
			const {sections} = this.props.part;
			return (
				<>
					{this.props.index !== 0 && sections && sections.length > 0 && this.renderSectionButtons(sections)}
					{section && <Section section={section} showHideButton={this.props.index === 2}/>}
				</>
			);
		}
		else{
			return (
				<div>Empty</div>
			)
		}
	}
}


export default index;
